import { ChatModal, SoundSettingsModal } from 'features/Modals';
import { ParticipantsModal } from 'features/Modals/ParticipantsModal';
import { ScreenShareModal } from 'features/Modals/ScreenShareModal/ScreenShareModal';
import { ContinueCallConfirmModal } from 'features/Modals/ContinueCallConfirmModal/ContinueCallConfirmModal';
import { KickedModal } from 'features/Moderation/components/KickedModal/KickedModal';
import { ModerationConfirmModal } from 'features/Moderation/components/ModerationActionsMenu/ModerationConfirmModal';
import { ParticipantsLimitModal } from 'features/ParticipantsLimit';
import { Participant, Room } from 'livekit-client';
import { createPortal } from 'react-dom';
import { observer } from 'mobx-react-lite';
import { selectOpenedModalName } from 'state/selectors';
import { VirtualBackgroundModal } from 'features/VirtualBackground/modals/VirtualBackgroundModal/VirtualBackgroundModal';
import { CallSettingsModal } from 'features/CallSettings/components/CallSettingsModal/CallSettingsModal';
import { CallNotStartedModal } from 'features/PreJoin/components/CallNotStartedModal';
import { WebinarModeModal } from 'features/Webinar/components/WebinarModeModal/WebinarModeModal';

export type ModalProviderPropsType = {
    room: Room | null;
    participants: Participant[];
};

export const enum ModalName {
    CHAT = 'chat',
    PARTICIPANTS = 'participants',
    SCREEN_SHARE = 'screen-share',
    VIRTUAL_BACKGROUND = 'virtual-background',
    KICKED = 'kicked',
    MODERATION_CONFIRM = 'moderation-confirm',
    CONTINUE_CALL_CONFIRM = 'continue-call-confirm',
    PARTICIPANTS_LIMIT = 'participants-limit',
    SOUND_SETTINGS = 'sound-settings',
    CALL_SETTINGS = 'call-settings',
    CALL_NOT_STARTED = 'call-not-started',
    WEBINAR_MODE = 'webinar-mode',
}

export type ModalsNameType = ModalName | null;

export type ModalPropsType = Record<string, unknown> | null;

const ModalProvider = observer(() => {
    const renderModal = () => {
        const openedModal = selectOpenedModalName();

        switch (openedModal) {
            case ModalName.CHAT:
                return <ChatModal />;
            case ModalName.PARTICIPANTS:
                return <ParticipantsModal />;
            case ModalName.SCREEN_SHARE:
                return <ScreenShareModal />;
            case ModalName.VIRTUAL_BACKGROUND:
                return <VirtualBackgroundModal />;
            case ModalName.KICKED:
                return <KickedModal />;
            case ModalName.MODERATION_CONFIRM:
                return <ModerationConfirmModal />;
            case ModalName.CONTINUE_CALL_CONFIRM:
                return <ContinueCallConfirmModal />;
            case ModalName.PARTICIPANTS_LIMIT:
                return <ParticipantsLimitModal />;
            case ModalName.SOUND_SETTINGS:
                return <SoundSettingsModal />;
            case ModalName.CALL_SETTINGS:
                return <CallSettingsModal />;
            case ModalName.CALL_NOT_STARTED:
                return <CallNotStartedModal />;
            case ModalName.WEBINAR_MODE:
                return <WebinarModeModal />;
            default:
                return null;
        }
    };

    const modalNode = document.getElementById('modal-root');
    const modalContent = renderModal();

    if (!modalContent || !modalNode) return null;

    return createPortal(modalContent, modalNode);
});

export { ModalProvider };
